export default __webpack_public_path__ + "static/media/ArrowRight.8011e3b1.svg";